"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.AvailabilityAndPricesDto = void 0;
var class_validator_1 = require("class-validator");
var class_transformer_1 = require("class-transformer");
var Authentication = (function () {
    function Authentication() {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], Authentication.prototype, "Username");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], Authentication.prototype, "Password");
    return Authentication;
}());
var Header = (function () {
    function Header() {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Authentication; }),
        __metadata("design:type", Authentication)
    ], Header.prototype, "Authentication");
    return Header;
}());
var Children = (function () {
    function Children() {
    }
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Transform(function (val) { return (Array.isArray(val) ? val : [val]); }),
        __metadata("design:type", Array)
    ], Children.prototype, "age");
    return Children;
}());
var RoomOccupancy = (function () {
    function RoomOccupancy() {
    }
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], RoomOccupancy.prototype, "adults");
    __decorate([
        class_validator_1.ValidateIf(function (object, value) { return value !== ''; }),
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Children; }),
        __metadata("design:type", Children)
    ], RoomOccupancy.prototype, "children");
    return RoomOccupancy;
}());
var HotelIdentifiers = (function () {
    function HotelIdentifiers() {
    }
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Transform(function (val) { return (Array.isArray(val) ? val : [val]); }),
        __metadata("design:type", Array)
    ], HotelIdentifiers.prototype, "hotelId");
    return HotelIdentifiers;
}());
var Rooms = (function () {
    function Rooms() {
    }
    __decorate([
        class_transformer_1.Type(function () { return RoomOccupancy; }),
        class_transformer_1.Transform(function (val) { return (Array.isArray(val) ? val : [val]); }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", RoomOccupancy)
    ], Rooms.prototype, "roomOccupancy");
    return Rooms;
}());
var AvailabilityRequest = (function () {
    function AvailabilityRequest() {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return HotelIdentifiers; }),
        __metadata("design:type", HotelIdentifiers)
    ], AvailabilityRequest.prototype, "hotelIdentifiers");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], AvailabilityRequest.prototype, "arrivalDate");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], AvailabilityRequest.prototype, "departureDate");
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Rooms; }),
        __metadata("design:type", Rooms)
    ], AvailabilityRequest.prototype, "rooms");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], AvailabilityRequest.prototype, "currency");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], AvailabilityRequest.prototype, "language");
    return AvailabilityRequest;
}());
var Body = (function () {
    function Body() {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return AvailabilityRequest; }),
        __metadata("design:type", AvailabilityRequest)
    ], Body.prototype, "availabilityRequest");
    return Body;
}());
var Envelope = (function () {
    function Envelope() {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Header; }),
        __metadata("design:type", Header)
    ], Envelope.prototype, "Header");
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Body; }),
        __metadata("design:type", Body)
    ], Envelope.prototype, "Body");
    return Envelope;
}());
var AvailabilityAndPricesDto = (function () {
    function AvailabilityAndPricesDto() {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return Envelope; }),
        __metadata("design:type", Envelope)
    ], AvailabilityAndPricesDto.prototype, "Envelope");
    return AvailabilityAndPricesDto;
}());
exports.AvailabilityAndPricesDto = AvailabilityAndPricesDto;
//# sourceMappingURL=availablity-body-transform.dto.js.map